module.exports={render:function (){with(this) {
  return _m(0)
}},staticRenderFns: [function (){with(this) {
  return _h('header', [_h('div', {
    staticClass: "header__back"
  }, [_h('div', {
    staticClass: "header__container"
  }, [_h('div', {
    staticClass: "header__avatar"
  }, [_h('img', {
    staticClass: "avatar__icon",
    attrs: {
      "src": require("../assets/profile.png")
    }
  })])])])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
 ** module id = 29
 ** module chunks = 1
 **/